import { render, staticRenderFns } from "./OrgBranch.vue?vue&type=template&id=7bbd5972&scoped=true"
import script from "./OrgBranch.vue?vue&type=script&lang=js"
export * from "./OrgBranch.vue?vue&type=script&lang=js"
import style0 from "./OrgBranch.vue?vue&type=style&index=0&id=7bbd5972&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd5972",
  null
  
)

export default component.exports